import React from 'react';
import PropTypes from 'prop-types';

import { PropertyView } from './view';

export const Property = ({
    isCollapsible,
    headline,
    children,
    isDetailsWrapper
}) => {
    const collapse = (event) => {
        event.target.parentElement.classList.toggle('property--active');
    };

    return (<PropertyView isCollapsible={ isCollapsible } isDetailsWrapper={ isDetailsWrapper } headline={ headline } collapse={ collapse }>{ children }</PropertyView>);
};

PropertyView.defaultProps = {
    isDetailsWrapper: false
};

Property.propTypes = {
    isCollapsible: PropTypes.bool.isRequired,
    headline: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    isDetailsWrapper: PropTypes.bool.isRequired
};